/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { IActionContext } from '@msdyn365-commerce/core';
import { updateLineDeliverySpecificationsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
import { Cart, LineDeliverySpecification } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';

import { ICartActionResultWithCart } from './cart-action-result';

export default async function updateCartLineDeliverySpecificationsInternal(cart: Readonly<Cart | undefined>, cartLineDeliverySpecifications: LineDeliverySpecification[], actionContext: IActionContext): Promise<ICartActionResultWithCart> {
    if (!cart || !cart.CartLines || cartLineDeliverySpecifications.length === 0) {
        return { cart: undefined, status: 'FAILED', substatus: 'EMPTYCART' };
    }

    return updateLineDeliverySpecificationsAsync(
        { callerContext: actionContext },
        cart.Id,
        cartLineDeliverySpecifications
    )
        .then(newCart => {
            return <ICartActionResultWithCart> { cart: newCart, status: 'SUCCESS' };
        }).catch(error => {
            actionContext.telemetry.warning(error);
            actionContext.telemetry.debug('Unable to updateLineDeliverySpecificationsAsync');

            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- existing error type.
            return <ICartActionResultWithCart> { cart: undefined, status: 'FAILED', errorDetails: { LocalizedMessage: error.message } };
        });
}
